import React, { Component } from "react";
import Floodbtn from "../molecules/Floodbtn";
import Gradhead from "../molecules/Gradhead";
import Link from "gatsby-link";
import cx from "classnames";
import BlogSlat from "../molecules/BlogSlat";
import BlogSlatMinor from "../molecules/BlogSlatMinor";

class BlogExcerpt extends Component {
  render() {
    let { md, json } = this.props;
    let posts = [];
    md.edges.forEach(({ node }) => {
      posts.push({
        excerpt: node.excerpt,
        title: node.frontmatter.title,
        date: node.frontmatter.date,
        uri: node.fields.slug,
        author: node.frontmatter.author
      });
    });
    json.edges.forEach(({ node }) => {
      posts.push({
        excerpt: node.excerpt,
        title: node.title,
        date: node.date,
        uri: node.page,
        author: node.author
      });
    });
    return (
      <section className="c-blogexcerpt">
        <div className="container">
          <div className="u-center u-clearfix">
            <Gradhead>In our blog</Gradhead>
          </div>
          <Floodbtn>
            <Link to="/blog/">See more</Link>
          </Floodbtn>

          <BlogSlat entry={posts[0]} />
          <hr />
          <div className="u-row">
            {posts[1] && (
              <div className="u-col u-col-6">
                <BlogSlatMinor entry={posts[1]} />
              </div>
            )}
            {posts[2] && (
              <div className="u-col u-col-6">
                <BlogSlatMinor entry={posts[2]} />
              </div>
            )}
          </div>
        </div>
      </section>
    );
  }
}

export default BlogExcerpt;



// WEBPACK FOOTER //
// ./src/organisms/BlogExcerpt.js